<template>
  <div class="entrutable">
    <div class="titlec between">
      <div class="tilist flex_start">
        <div
          class="titem"
          v-for="(item, index) in taglist"
          :key="index"
          :class="{ act: isact == index }"
          @click="tagcli(index)"
        >
          {{ item }}
        </div>
      </div>
      <div class="timo">更多></div>
    </div>
    <div class="cont">
      <!-- <div class="tabti">
            
        </div>
        <div class="tabcont"></div> -->

      <div class="table">
        <div class="tabti flex">
          <div class="td1">案件委托标题</div>
          <div class="td2">涉案金额</div>
          <div class="td2">审核</div>
          <div class="td2">地区</div>
          <div class="td2">发布时间</div>
          <div class="td2">联系方式</div>
          <div class="td3">操作</div>
        </div>

        <div
          class="tabcoitem flex"
          v-for="(item, index) in 17"
          :key="index"
          :class="{ itmbg: index % 2 == 1 }"
        >
          <div class="td1 ellipsis">
            未经原车主同意，将车辆过户，押金未退，怎么维，怎么维
          </div>
          <div class="td2 pric">¥5万以下</div>
          <div class="td2 mo_opera">人工审核</div>
          <div class="td2 color99">江苏徐州</div>
          <div class="td2 color99">12小时前</div>
          <div class="td2 color99">188******12</div>
          <div class="td3 operation" @click="tojump">查看案件详情>></div>
        </div>
		
		
      </div>
	  
	  <div class="pagination mt50 ">
	    <el-pagination
	      background
	      layout="prev, pager, next"
	      :page-count="pageCount"
	      :current-page="currentPage"
	      :pager-count="5"
	      @current-change="turnpage"
	      @prev-click="turnpage(--currentPage)"
	      @next-click="turnpage(++currentPage)"
	    >
	    </el-pagination>
	    <span class="FontGray FontSize14 mt20">[ 共 <span class="FontBlack">{{pageCount}}</span> 页 ]</span>
	  </div>
	  
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    isact: 0,
    taglist: ["最新", "一般", "加急", "推荐", "本地案源"],
	currentPage: 1, //当前
	pageCount: 17, //总页数
	total: 17, //总条目
  }),
  methods: {
    tagcli(index) {
      this.isact = index;
    },
    tojump(){
      this.$router.push({
        path:'/question/entrustdet'
      })
    },
	turnpage(e) {
	  console.log(e);
	},
  },
};
</script>

<style lang="scss" scope>
.entrutable {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .titlec {
    .tilist {
      .titem {
        width: 140px;
        height: 48px;
        cursor: pointer;
        text-align: center;
        line-height: 48px;
        font-size: 20px;
        color: #333333;
        &.act {
          color: #fff;
          background: #0465ea;
        }
      }
    }
    .timo {
      font-size: 16px;
      color: #666666;
      line-height: 16px;
    }
  }
  .cont {
    .table {
      margin-top: 10px;
      width: 100%;
      background: #ffffff;
      text-align: center;
      box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
      .td1 {
        width: 380px;
        padding: 0 30px;
        text-align: center;
      }
      .td2 {
        width: 126px;
        text-align: center;
      }
      .td3 {
        width: 180px;
        text-align: center;
      }
      .tabti {
        width: 100%;
        height: 54px;
        line-height: 54px;
        background: #f9fbff;
        font-size: 16px;
        color: #333333;
        font-weight: bold;
      }
      .tabcoitem {
        width: 100%;
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        color: #666666;
        background: #ffffff;
        .pric {
          color: #f25618;
        }
        .operation {
          cursor: pointer;
        }

        .color99 {
          color: #999;
        }
        &:hover {
          .operation {
            color: #0465ea;
          }
        }
        &.itmbg {
          background-color: #f9fbff;
        }
      }
    }
  }
}
.pagination{
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
</style>